// extracted by mini-css-extract-plugin
module.exports = {"extraSpace":"NavbarCustom_extraSpace__3D5tW"};